export default __webpack_public_path__ + "static/media/import2.3f5ed646.svg";